<template>
  <LazyHomeCommonLayout>
    <template #content>
      <LazyHomeEventMain />
      <LazyHomeEventContent />
      <LazyHomeEventContact />
      <LazyHomeEventBottom />
    </template>
  </LazyHomeCommonLayout>
</template>

<script setup lang="ts">
import {useI18n} from "vue-i18n";

const {t} = useI18n({useScope: 'local'})

useHead({
  title: t('title'),
  meta: [
    {
      name: 'description',
      content: t('description')
    },
    {
      name: 'title',
      content: t('title')
    },
    {
      name: 'robots',
      content: 'index,follow'
    }
  ]
})
</script>

<i18n>
{
  "en": {
    "title": "Codepresso Launch Event",
    "description": "Get a free trial of our innovative developer skills assessment and management service."
  },
  "ko": {
    "title": "코드프레소 오픈 이벤트",
    "description": "조직 진단부터 개발자 채용까지, HR 업무를 정량적 평가와 데이터 기반 관리 서비스를 통해 효율적으로 진행해보세요."
  }
}
</i18n>
